/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plum_Pearl_Otter_WadeInputs */

const en_plum_pearl_otter_wade = /** @type {(inputs: Plum_Pearl_Otter_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for comment analysis to finish before starting topic classification.`)
};

const de_plum_pearl_otter_wade = /** @type {(inputs: Plum_Pearl_Otter_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartet auf Abschluss der Kommentaranalyse, bevor die Themenklassifizierung startet.`)
};

/**
* | output |
* | --- |
* | "Waiting for comment analysis to finish before starting topic classification." |
*
* @param {Plum_Pearl_Otter_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plum_pearl_otter_wade = /** @type {((inputs?: Plum_Pearl_Otter_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plum_Pearl_Otter_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plum_pearl_otter_wade(inputs)
	return de_plum_pearl_otter_wade(inputs)
});